import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';
import { LoginOrApp } from './LoginOrApp';
import { FormRedefinirSenha } from '../modulos/login/FormRedefinirSenha';

export function Router(){
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/redefinir-senha/:token"
          element={<FormRedefinirSenha />}
        />
        <Route
          path="*"
          element={<LoginOrApp />}
        />
    </Routes>
    </BrowserRouter>
    );
}